export const GetShortFormOfString = (string) => {
  const abbr = string
    ?.split(" ")
    ?.map((word) => word[0])
    ?.join("");
  return abbr?.toUpperCase();
};
